'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLang(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M3.30633 11.6167C3.55961 11.6167 3.75128 11.5071 4.05933 11.2265L6.05819 9.41929H9.35768C11.0416 9.42613 12 8.44039 12 6.77696V2.64918C12 0.978891 11.0416 0 9.35768 0H2.64917C0.965205 0 0 0.978891 0 2.64918V6.77696C0 8.44039 1.00628 9.41929 2.58072 9.41929H2.73131V10.9664C2.73131 11.3634 2.94352 11.6167 3.30633 11.6167ZM6.01029 5.53075C5.64748 5.53075 5.44213 5.33223 5.42159 4.96943L5.33945 2.7036C5.31891 2.32711 5.60642 2.05329 6.00345 2.05329C6.40048 2.05329 6.68799 2.32711 6.66745 2.7036L6.57847 4.96258C6.56477 5.33223 6.36626 5.53075 6.01029 5.53075ZM6.01025 7.62601C5.59952 7.62601 5.28463 7.35904 5.28463 6.96199C5.28463 6.56496 5.59952 6.29799 6.01025 6.29799C6.41413 6.29799 6.72902 6.56496 6.72902 6.96199C6.72902 7.36588 6.41413 7.62601 6.01025 7.62601Z", fill: "currentColor" })));
}

module.exports = SvgLang;
//# sourceMappingURL=Lang.js.map
